# Let the obfiscator compress these down by assigning them to variables
export _undefined       = undefined
export _undefinedString = 'undefined'
